import { createFileRoute } from '@tanstack/react-router'
import { SupportEnterScreen } from '@/features/support/support-enter-screen'

/** Public route: a platform admin's handoff into the company app (ADR-0033). */
export const Route = createFileRoute('/support/enter')({ component: SupportEnterScreen })
